// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"819f4bb9","769":"448cd256"}[chunkId] + ".chunk.css";
};